import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import {
  Modal,
  Form,
  Button,
  OverlayTrigger,
  Tooltip,
  Alert,
  Row,
  Col,
} from 'react-bootstrap'
import Navbar from '../../components/navbar/navbar.jsx'
import '../pedido-editar/pedido-editar.css'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import api from '../../services/api.js'
import AutocompleteProdutoMatch from '../../components/auto-complete-match-produto/complete-match.jsx'
import AutocompleteClienteNode from '../../components/autocomplete-cliente/autocomplete-clientenode.jsx'
import apinode from '../../services/apinode.js'
import { set } from 'date-fns'
import { NumberFormat } from 'react-number-format'
import swal from 'sweetalert'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import ModalIncluirCliente from './ModalIncluirCliente.jsx'
import clientesPDF from './report.jsx'
import { toast } from 'react-toastify'

function Orcamentos() {
  const { id_pedido } = useParams()
  const navigate = useNavigate()
  const { conta } = useParams()
  const [estaBuscando, setEstaBuscando] = useState(true)
  const [textoDigitado, setTextoDigitado] = useState('')

  const [dt_pedido, setDtPedido] = useState('')
  const [id_cond_pagto, setIdCondPagto] = useState(0)
  const [dt_entrega, setDtEntrega] = useState('')
  const [obs, setObs] = useState('')
  const [produtos, setProdutos] = useState([])
  const [vl_total, setVlTotal] = useState(0)
  const [msg, setMsg] = useState('')
  const [desconto, setDesconto] = useState(0)
  const [vendedor, setVendedor] = useState('')
  const [prestador, setPrestador] = useState('')
  const [indicacaoVenda, setIndicacaoVenda] = useState('')
  const [lista_produtos, setListaProdutos] = useState([])
  const [lista_clientes, setListaClientes] = useState([])
  const [cond_pagtos, setCondPagtos] = useState([])
  const [produtoBanco, setProdutoBanco] = useState('')
  const [matchResultado, setMatchResultado] = useState(null)
  const [matchproduto, setMatchProduto] = useState('')
  const [codinterno, setCodigoInterno] = useState('')
  const [id_cliente, setIdCliente] = useState('')
  const [nomeCliente, setNomeCliente] = useState('')
  const [cliente, setCliente] = useState('')
  const [cpf, setCpf] = useState('')
  const [dadospedido, setDadosPedido] = useState('')
  const [vendedores, setVendedores] = useState([])
  const [prestadores, setPrestadores] = useState([])
  const [parceiros, setParceiros] = useState([])
  const [parceiro, setParceiro] = useState('')
  const [detalhesPedido, setDetalhesPedido] = useState('')
  const [clienteSemCada, setSemCad] = useState('')
  const [dadosEmp, setDadosEmp] = useState([])
  const [totalCusto, setTotalCusto] = useState(0)
  const [itemSelecionado, setItemSelecionado] = useState(null)
  const [inputValue, setInputValue] = useState('')
  const [clientes, setClientes] = useState([])

  const [showModal, setShowModal] = useState(false)

  function handleImg(value, index) {
    console.log(value)
    setProdutos((prevProdutos) => {
      const newProdutos = [...prevProdutos]
      newProdutos[index].image = value || 'no-image.jpg'
      return newProdutos
    })
  }

  const handleInserir = () => {
    if (itemSelecionado !== null && inputValue.trim() !== '') {
      const novosProdutos = [...produtos]
      novosProdutos[itemSelecionado] = {
        ...novosProdutos[itemSelecionado],
        grupo_item: inputValue.trim() ? inputValue.toUpperCase() : inputValue,
      }
      setProdutos(novosProdutos)
      setItemSelecionado(null) // Fecha o modal após a inserção
      setInputValue('') // Limpa o valor do input
      console.log(produtos)
    }
  }

  const handleInputChange = (e) => {
    setInputValue(e.target.value)
    if (itemSelecionado !== null) {
      const novosProdutos = [...produtos]
      novosProdutos[itemSelecionado] = {
        ...novosProdutos[itemSelecionado],
        grupo_item: e.target.value.trim()
          ? e.target.value.toUpperCase()
          : e.target.value,
      }
      setProdutos(novosProdutos)
    }
  }

  // Calcula o total_custo somando o total_custo de cada produto
  const calcularTotalCusto = () => {
    return produtos.reduce(
      (total, produto) => total + (produto.total_custo || 0),
      0,
    )
  }

  React.useEffect(() => {
    setTotalCusto(calcularTotalCusto())
  }, [produtos])

  const handlecloseTela = () => {
    navigate(-1)
  }

  const moverProdutoParaCima = (index) => {
    if (index === 0) return

    setProdutos((prevProdutos) => {
      const novosProdutos = [...prevProdutos]
      const produtoSelecionado = novosProdutos[index]
      const produtoAnterior = novosProdutos[index - 1]
      novosProdutos[index - 1] = produtoSelecionado
      novosProdutos[index] = produtoAnterior
      return novosProdutos
    })
  }

  function handleCusto(vl, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].preco_custo = vl // Converte o valor para número

    // Verifica se o valor é um número válido
    if (!isNaN(updatedProdutos[index].preco_custo)) {
      updatedProdutos[index].total_custo =
        updatedProdutos[index].quantidade * updatedProdutos[index].preco_custo

      console.log('valor_total_custo:', updatedProdutos[index].total_custo) // Linha de depuração
    } else {
      // Se o valor não for um número válido, trate o erro aqui.
      // Por exemplo, você pode definir como 0 ou exibir uma mensagem de erro.
      updatedProdutos[index].total_custo = 0
      console.error('Erro: preco_custo não é um número válido.')
    }

    setProdutos(updatedProdutos)
  }

  const moverProdutoParaBaixo = (index) => {
    if (index === produtos.length - 1) return

    setProdutos((prevProdutos) => {
      const novosProdutos = [...prevProdutos]
      const produtoSelecionado = novosProdutos[index]
      const proximoProduto = novosProdutos[index + 1]
      novosProdutos[index + 1] = produtoSelecionado
      novosProdutos[index] = proximoProduto
      return novosProdutos
    })
  }

  function ImpPdf() {
    const dados_pedido = {
      numeroorc: id_pedido,
      cliente: nomeCliente,
      id_cliente: id_cliente || 0,
      id_pagamento: null,
      cod_vendedor: vendedor || null,
      data: dt_pedido || moment().format('YYYY-MM-DD'),
      valor: vl_total,
      desconto: desconto || null,
      desconto_din: desconto || null,
      id_parceiro: indicacaoVenda || null,
      cpf: cpf,
      cod_vendedor: vendedor || null,
      detalhes_pedido: detalhesPedido || 'Não informado',
      itens: produtos,
      empresa: dadosEmp,
      dadosCliente: clientes,
    }

    clientesPDF(dados_pedido, 'Resumo')
  }

  // Rest of your code...

  const handleSaveCliente = ({ cpf, nome }) => {
    setCpf(cpf)
    setNomeCliente(nome)
    setSemCad(true) // Indicate that the client is not registered
    setShowModal(false) // Close the modal after saving
  }

  const alternarModoBusca = () => {
    setEstaBuscando((estadoAnterior) => !estadoAnterior)
  }

  const handleDescontoTotal = (value) => {
    const descontoTotal = parseFloat(value)

    if (isNaN(descontoTotal) || descontoTotal <= 0) {
      // If the discount value is not a valid number or less than or equal to zero, don't apply any discounts
      setDesconto(0) // Reset the discount to zero
      setProdutos(produtos) // Keep the products unchanged
      return
    }

    const updatedProdutos = produtos.map((produto) => {
      const quantidade = parseFloat(produto.quantidade)
      const valorUnitario = parseFloat(produto.valorunitario)

      if (!isNaN(quantidade) && !isNaN(valorUnitario)) {
        const valorDesconto =
          (descontoTotal * produto.valor_total_item) / vl_total
        const valorTotalItem = quantidade * valorUnitario - valorDesconto

        return {
          ...produto,
          desconto: valorDesconto,
          valor_total_item: valorTotalItem,
        }
      }

      return produto
    })

    setDesconto(descontoTotal)
    setProdutos(updatedProdutos)
  }

  const handleIdCliente = (id) => {
    setIdCliente(id)
  }

  const handleCpf = (cpf) => {
    setCpf(cpf)
  }

  const handleDescontoChange = (value, index) => {
    const updatedProdutos = [...produtos]
    const produto = updatedProdutos[index]

    const quantidade = parseFloat(produto.quantidade)
    const valorUnitario = parseFloat(produto.valorunitario)
    const desconto = parseFloat(value)

    if (!isNaN(quantidade) && !isNaN(valorUnitario) && !isNaN(desconto)) {
      produto.valor_total_item = quantidade * valorUnitario - desconto
      produto.desconto = value
    } else {
      produto.valor_total_item = 0
    }

    setProdutos(updatedProdutos)
  }

  const handleOpenModal = () => {
    setShowModal(true)
  }

  const parseDecimalValue = (value) => {
    const sanitizedValue = value.replace(',', '.')
    const parsedValue = parseFloat(sanitizedValue)
    return isNaN(parsedValue) ? '' : parsedValue.toFixed(2)
  }

  const formatValue = (value) => {
    if (value == null) {
      return '' // Return an empty string or any default value for null or undefined values
    }
    return value.toLocaleString('pt-BR', { minimumFractionDigits: 2 })
  }

  const handleNomeCliente = (nome) => {
    setNomeCliente(nome)
    setDadosPedido((prevState) => ({
      ...prevState,
      cliente: nome,
    }))
  }

  const handleObsChange = (value, index) => {
    const updatedProdutos = [...produtos] // Create a copy of the produtos array
    updatedProdutos[index].obs = value // Update the obs value of the corresponding product
    setProdutos(updatedProdutos) // Update the state with the modified array
  }

  function handleProdutoIdChange(id, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].codigo = id
    setProdutos(updatedProdutos)
  }

  function handleProdutoNomeChange(nome, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].descricao = nome
    setProdutos(updatedProdutos)
  }

  function handleProdutoInternoChange(prodInterno, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].id = prodInterno
    setProdutos(updatedProdutos)
  }

  function AdicionarProduto() {
    const prod = {
      id: uuidv4(),
      codigo: 0,
      descricao: '',
      quantidade_nova: 1,
      valorunitario: 0,
      valor_total_item: 0,
      desconto: 0,
      image: 'no-image.jpg',
    }

    setProdutos([...produtos, prod])
  }

  function ExcluirProduto(index) {
    setProdutos((prevState) => prevState.filter((p, i) => i !== index))
  }

  function buscapedido(idpedido) {
    const pedido = '12345'

    api
      .get(`/getorcamentos/${idpedido}/${conta}`, {
        headers: {
          'Accept-Charset': 'utf-8',
        },
      })
      .then((response) => {
        console.log(response.data)
        setProdutos(response.data.itens)
        setDadosPedido(response.data)
        const { cliente } = response.data
        setNomeCliente(cliente)

        setDadosPedido((prevState) => ({
          ...prevState,
          cliente: cliente,
        }))
      })
      .catch((error) => {
        console.error(error)
      })
  }

  function formatDate(dateString) {
    if (!dateString) return '' // Handle empty or undefined dateString

    const date = new Date(dateString)

    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')

    return `${year}-${month}-${day}`
  }

  function CarregarDadosPedido(id_ped) {
    if (id_ped > 0) {
      // setIdCliente(dadospedido?.id_cliente ?? 0);
      // setNomeCliente(dadospedido?.cliente);
      // setCpf(dadospedido?.cpf)

      setClientes(dadospedido?.clientes)

      setDtPedido(formatDate(dadospedido?.data))

      setVendedor(dadospedido?.cod_vendedor)
      setParceiro(dadospedido?.id_parceiro)

      setIdCondPagto(2)
      setDtEntrega('2023-10-30')
      // setObs("Teste");
      setDesconto(dadospedido?.desconto_din)
      setDetalhesPedido(dadospedido?.detalhes_pedido)
    } else {
      setIdCliente(0)
      setDtPedido(moment().format('YYYY-MM-DD'))
      setIdCondPagto(0)
      setDtEntrega(moment().format('YYYY-MM-DD'))
      setObs('')
      setDesconto(0)
      setVendedor('')
      setIndicacaoVenda('')
      setProdutos([])
    }
  }

  function PesquisarClientes() {
    setListaClientes([])
  }

  function PesquisarProdutos() {
    setListaProdutos([
      { id_item: 1, id_produto: 1, descricao: 'MONITOR DELL' },
      { id_item: 2, id_produto: 2, descricao: 'HD SEAGATE 2TB' },
      { id_item: 3, id_produto: 3, descricao: 'MOUSE LOGITECH' },
    ])
  }

  function PesquisarCondPagtos() {
    setCondPagtos([
      { id_cond_pagto: 1, cond_pagto: '30 Dias' },
      { id_cond_pagto: 2, cond_pagto: '45 Dias' },
    ])
  }

  function handleDescricaoChange(value, index) {
    setProdutos((prevProdutos) => {
      const newProdutos = [...prevProdutos]
      newProdutos[index].descricao = value
      return newProdutos
    })
  }

  function handleQtdChange(qtd, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].quantidade = qtd
    updatedProdutos[index].valor_total_item =
      qtd * updatedProdutos[index].valorunitario

    // Calcula o novo preço de custo
    updatedProdutos[index].total_custo =
      qtd * updatedProdutos[index].preco_custo

    setProdutos(updatedProdutos)
  }

  function handleVlUnitChange(vl, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].valorunitario = vl
    updatedProdutos[index].valor_total_item =
      updatedProdutos[index].quantidade * vl

    console.log('valor_total_item:', updatedProdutos[index].valor_total_item) // Linha de depuração

    if (
      typeof updatedProdutos[index].valor_total_item === 'number' &&
      !isNaN(updatedProdutos[index].valor_total_item)
    ) {
      updatedProdutos[index].valor_novo =
        updatedProdutos[index].valor_total_item
    } else {
      // Se o valor não for um número válido, trate o erro aqui.
      // Por exemplo, você pode definir como 0 ou exibir uma mensagem de erro.
      updatedProdutos[index].valor_novo = 0
      console.error('Erro: valor_total_item não é um número válido.')
    }

    setProdutos(updatedProdutos)
  }

  function CalculaTotal() {
    let total = 0
    produtos.forEach((prod) => {
      total += prod.valor_total_item
    })
    setVlTotal(total)
  }

  function SalvarDados() {
    const dados_pedido = {
      cliente: nomeCliente,
      id_cliente: id_cliente,
      id_pagamento: null,
      id_prestador: prestador,
      cod_vendedor: vendedor,
      data: dt_pedido || moment().format('YYYY-MM-DD'),
      valor: vl_total,
      desconto: desconto,
      desconto_din: desconto,
      id_parceiro: indicacaoVenda || null,
      cpf: cpf,
      cod_vendedor: vendedor || null,
      detalhes_pedido: detalhesPedido || 'Não informado',
      itens: produtos,
    }

    if (!nomeCliente) {
      swal('Erro', 'O campo cliente é obrigatório.', 'warning')
      return
    }

    apinode
      .post(`/vendedores/postorc/${conta}`, dados_pedido)
      .then((response) => {
        console.log(response.data)
        swal('Sucesso', response.data.message, 'success')
        // Redirecionar para a homepage após o sucesso
        // Usando a função history.push()
        navigate(`/orcamento/${conta}/${response.data.orcamento}`)
      })
      .catch((error) => {
        console.error(error)
        swal('Erro', error.response.data.message, 'warning')
        // Faça o tratamento adequado do erro aqui
        // Por exemplo, exibir uma mensagem de erro na página
        // E permitir que o usuário corrija os dados antes de tentar salvar novamente
      })
  }

  const handleTextoChange = (texto) => {
    setTextoDigitado('texto' + texto)
  }

  const reqToken = async (conta) => {
    try {
      const response = await api.get('/emp', {
        params: {
          token: conta,
        },
      })

      if (response.status === 200) {
        const token = response.data?.ID_CONTA
        console.log('token: ' + token)

        if (!token) {
          // Sessão expirada ou token não encontrado
          swal(
            'Sessão expirada',
            'Por favor, feche e abra novamente.',
            'warning',
          )
        } else {
          // Atribuição para o state ou local storage (se necessário)
          setDadosEmp([response.data]) // Define o state "dadosEmp" com os dados recebidos
          localStorage.setItem('id_conta', token) // Define o "id_conta" no local storage
        }
      } else {
        console.log('Erro ao requisitar token. Status: ' + response.status)
      }
    } catch (error) {
      console.error('Erro na requisição:', error)
      // Tratamento de erro adicional, se necessário
      // Por exemplo, exibir uma mensagem de erro para o usuário
      swal('Erro na requisição', 'Ocorreu um erro ao buscar o token.', 'error')
    }
  }

  useEffect(() => {
    reqToken(conta)
    localStorage.setItem('id_conta', conta)
    console.log(conta)
    PesquisarClientes()
    PesquisarProdutos()
    PesquisarCondPagtos()

    // buscapedido(id_pedido);
    CarregarDadosPedido(id_pedido)
  }, [])

  function handleProdutoNomeChangeInput(nome, index) {
    const updatedProdutos = [...produtos]
    updatedProdutos[index].descricao = nome
    updatedProdutos[index].codigo = '999999'
    setProdutos(updatedProdutos)
  }

  useEffect(() => {
    CalculaTotal()
  }, [produtos])

  useEffect(() => {
    apinode
      .get(`vendedores/prestador?conta=${conta}`)
      .then((response) => {
        setPrestadores(response.data)
      })
      .catch((error) => {
        console.error(error)
      })

    // Fazer a requisição para obter os vendedores
    apinode
      .get(`vendedores/vendedor?conta=${conta}`)
      .then((response) => {
        setVendedores(response.data)
      })
      .catch((error) => {
        console.error(error)
      })

    apinode
      .get(`vendedores/parceiros?conta=${conta}`)
      .then((response) => {
        setParceiros(response.data)
      })
      .catch((error) => {
        console.error(error)
      })
  }, [])

  if (parceiros.length > 0) {
    parceiros.sort((a, b) => {
      const nomeA = a.PES_RAZAO.toLowerCase()
      const nomeB = b.PES_RAZAO.toLowerCase()
      if (nomeA < nomeB) {
        return -1
      }
      if (nomeA > nomeB) {
        return 1
      }
      return 0
    })
  }

  return (
    <>
      <Navbar />

      <div className="container-fluid mt-page form-pedido-editar">
        <div className="row col-lg-12 offset-lg-12">
          <div className="col-12 mb-4 mt-2">
            <h2 className="d-inline">
              {id_pedido > 0
                ? `Editar orçamento ${id_pedido}`
                : 'Novo Orçamento'}
            </h2>
          </div>

          <div className="col-md-8 mb-4">
            <label
              htmlFor="InputNome"
              className="form-label"
            >
              Cliente
            </label>
            <div className="d-flex">
              <AutocompleteClienteNode
                placeholder="Pesquisar cliente...."
                onClickNome={handleNomeCliente}
                onClickId={handleIdCliente}
                onClickCpf={handleCpf}
                busca={setSemCad}
                value={nomeCliente}
                className="form-control me-2"
              />
              <button
                className="btn btn-primary d-flex align-items-center"
                onClick={handleOpenModal}
              >
                <i className="bi bi-plus"></i>
              </button>
            </div>
          </div>
          <div className="col-md-4 mb-4">
            <label
              htmlFor="InputEmail"
              className="form-label"
            >
              Data orçamento
            </label>
            <input
              type="date"
              onChange={(e) => {
                const newDate = e.target.value
                setDtPedido(newDate)
              }}
              value={dt_pedido}
              className="form-control"
              id="InputEmail"
              aria-describedby="email"
            />
          </div>

          <div className="col-md-8 mb-4">
            <label
              htmlFor="InputNome"
              className="form-label"
            >
              Cond. Pagamento
            </label>

            <select
              name="cond_pagto"
              id="cond_pagto"
              onChange={(e) => setIdCondPagto(e.target.value)}
              value={id_cond_pagto}
              className="form-select"
              style={{ border: '1px solid #ced4da' }} // Estilo personalizado para o contorno
            >
              <option value="0">Selecione a cond. pagto</option>
              {cond_pagtos.map((c) => (
                <option
                  key={c.id_cond_pagto}
                  value={c.id_cond_pagto}
                >
                  {c.cond_pagto}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-4 mb-5">
            <label
              htmlFor="InputEmail"
              className="form-label"
            >
              Previsão Entrega
            </label>
            <input
              type="date"
              onChange={(e) => setDtEntrega(e.target.value)}
              value={dt_entrega}
              className="form-control"
              id="InputEmail"
              aria-describedby="email"
            />
          </div>

          <Row className="mb-4">
            <Col>
              <label
                htmlFor="InputNome"
                className="form-label"
              >
                Vendedor
              </label>

              <select
                onChange={(e) => setVendedor(e.target.value)}
                value={vendedor}
                className="form-control"
                id="InputNome"
                style={{ border: '1px solid #ced4da' }}
              >
                <option value="">Selecione um vendedor</option>
                {vendedores.map((vendedor) => (
                  <option
                    key={vendedor.COD_PESSOA}
                    value={vendedor.COD_PESSOA}
                  >
                    {vendedor.PES_RAZAO}
                  </option>
                ))}
              </select>
            </Col>

            <Col>
              <label
                htmlFor="InputNome"
                className="form-label"
              >
                Indicação de Venda
              </label>

              <select
                className="form-control"
                value={indicacaoVenda}
                onChange={(e) => setIndicacaoVenda(e.target.value)}
                style={{ border: '1px solid #ced4da' }} // Estilo personalizado para o contorno
              >
                <option value="">Selecione um parceiro</option>
                {parceiros.map((parceiro) => (
                  <option
                    key={parceiro.COD_PESSOA}
                    value={parceiro.COD_PESSOA}
                  >
                    {parceiro.PES_RAZAO}
                  </option>
                ))}
              </select>
            </Col>

            <Col>
              <label
                htmlFor="InputNome"
                className="form-label"
              >
                Prestador
              </label>

              <select
                className="form-control"
                value={prestador}
                onChange={(e) => setPrestador(e.target.value)}
                style={{ border: '1px solid #ced4da' }}
              >
                <option value="">Selecione um prestador</option>
                {prestadores.map((prestador) => (
                  <option
                    key={prestador.COD_PESSOA}
                    value={prestador.COD_PESSOA}
                  >
                    {prestador.PES_RAZAO}
                  </option>
                ))}
              </select>
            </Col>
          </Row>

          <Alert>É necessário salvar o orçamento para incluir produtos!</Alert>

          <div className="col-12">
            <label
              htmlFor="InputNome"
              className="form-label"
            >
              Desconto em Dinheiro
            </label>
            <input
              type="number"
              onChange={(e) => handleDescontoTotal(e.target.value)}
              value={desconto}
              className="form-control"
              id="InputNome"
            />
          </div>
          <div className="col-12">
            <label
              htmlFor="InputNome"
              className="form-label"
            >
              Observações
            </label>
            <textarea
              type="text"
              onChange={(e) => setDetalhesPedido(e.target.value)}
              value={detalhesPedido}
              className="form-control"
            ></textarea>
          </div>

          <div className="col-12 mt-3">
            {msg.length > 0 && (
              <div className="alert alert-danger mt-4 text-center">{msg}</div>
            )}

            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-outline-primary me-2"
                onClick={handlecloseTela}
              >
                Cancelar
              </button>

              <button
                type="button"
                className="btn btn-success me-2"
                onClick={SalvarDados}
              >
                Salvar Dados
              </button>
            </div>
          </div>
        </div>
        {showModal && (
          <ModalIncluirCliente
            onSaveCliente={handleSaveCliente}
            onCancel={() => setShowModal(false)}
          />
        )}

        <Modal
          show={itemSelecionado !== null}
          onHide={() => setItemSelecionado(null)}
        >
          <Modal.Header closeButton>
            <Modal.Title>Informações do Grupo</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {itemSelecionado !== null && (
              <div>
                <p>Grupo: {produtos[itemSelecionado].grupo}</p>
                {/* Outras informações do grupo */}
                <Form.Control
                  type="text"
                  value={inputValue}
                  onChange={handleInputChange}
                  placeholder="Digite algo..."
                />
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={handleInserir}
              variant="primary"
            >
              Inserir
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}

export default Orcamentos
